import { render, staticRenderFns } from "./detailsInsurance.vue?vue&type=template&id=03d1af6e"
import script from "./detailsInsurance.vue?vue&type=script&lang=js"
export * from "./detailsInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports